var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStaking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5043 28.8158V35.9518C39.5043 36.2238 39.5043 36.4638 39.5043 36.7038C38.7683 40.8318 32.0483 44.0478 23.8403 44.0478C15.6323 44.0478 8.92835 40.8478 8.20835 36.7038C8.19097 36.4533 8.19097 36.2022 8.20835 35.9518V28.6078C8.20835 27.2638 8.99235 26.1598 9.93635 26.1598C10.1739 26.1593 10.4068 26.2258 10.6083 26.3518C14.7019 28.7442 19.3715 29.9725 24.1123 29.9038C28.6596 29.9343 33.1368 28.782 37.1043 26.5598C37.3058 26.4338 37.5388 26.3673 37.7763 26.3678C38.7203 26.3678 39.5043 27.4718 39.5043 28.8158Z",
    fill: "url(#paint0_linear_597_13563)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6246 33.856H20.9286C20.2395 33.856 19.6806 34.4148 19.6806 35.104C19.6806 35.7933 20.2395 36.352 20.9286 36.352H26.6246C27.3139 36.352 27.8726 35.7933 27.8726 35.104C27.8726 34.4148 27.3139 33.856 26.6246 33.856Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8082 4C14.8643 4 8.09626 7.2 8.09626 11.536C8.16413 12.8281 8.73909 14.0413 9.69626 14.912C10.349 15.5446 11.0868 16.0832 11.8883 16.512C15.5913 18.3306 19.685 19.2098 23.8082 19.072C27.9595 19.2167 32.0822 18.3318 35.8082 16.496C36.6097 16.0672 37.3475 15.5286 38.0002 14.896C38.9574 14.0253 39.5324 12.8121 39.6002 11.52C39.5042 7.232 32.7362 4 23.8082 4ZM33.0082 14.912C30.0649 16.0021 26.9469 16.5443 23.8082 16.512C20.675 16.5431 17.5624 16.0008 14.6243 14.912C13.6089 14.5371 12.6628 13.9964 11.8243 13.312C11.5397 13.1032 11.3017 12.8375 11.1255 12.5317C10.9492 12.226 10.8384 11.8869 10.8003 11.536C10.8003 9.216 16.3683 6.624 23.8082 6.624C31.2482 6.624 36.8322 9.216 36.8322 11.536C36.794 11.8869 36.6834 12.226 36.507 12.5317C36.3309 12.8375 36.0929 13.1032 35.8082 13.312C34.96 13.9995 34.0029 14.5403 32.9762 14.912H33.0082Z",
    fill: "url(#paint1_linear_597_13563)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.968 14.912C37.3153 15.5446 36.5775 16.0832 35.776 16.512C36.0605 16.7208 36.2985 16.9865 36.4748 17.2923C36.6511 17.598 36.7618 17.9371 36.8 18.288C36.8 20.608 31.232 23.2001 23.776 23.2001C16.32 23.2001 10.768 20.592 10.768 18.272C10.8061 17.9211 10.9169 17.582 11.0932 17.2763C11.2695 16.9705 11.5074 16.7048 11.792 16.496C10.9905 16.0672 10.2527 15.5286 9.6 14.896C9.12307 15.3213 8.73587 15.8376 8.46112 16.4146C8.18637 16.9916 8.0296 17.6176 8 18.256C8 22.5441 14.768 25.7921 23.712 25.7921C32.656 25.7921 39.44 22.5921 39.44 18.256C39.4093 16.9909 38.8803 15.789 37.968 14.912Z",
    fill: "#3F237B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_597_13563",
    x1: 26.6854,
    y1: 4.96317,
    x2: 13.3105,
    y2: 40.0492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_597_13563",
    x1: 2446.27,
    y1: 4939.09,
    x2: 7148.19,
    y2: 5133.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C8BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F37D2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaking);
export default __webpack_public_path__ + "static/media/staking.ae72ca5b1463ebb2bc909492e51959c9.svg";
export { ForwardRef as ReactComponent };